import React, { useEffect, useState } from "react";
import Input from "../../components/Input";
import { useForm } from "react-hook-form";
import { useLoginMutation } from "../../apis/loginApis";
import toast from "react-hot-toast";
import OtpForm from "../Otp/OtpForm";
import { addProfileData } from "../../features/auth/authSlice";
import { useDispatch } from "react-redux";
import { NavLink, useNavigate } from "react-router-dom";
import { useProfileData } from "../../apis/profileApis";
import LanguagePicker from "../../components/common/LanguagePicker";

const LoginSaudi: React.FC = () => {
  const [email, setEmail] = useState("");
  const [isSuccess, setIsSuccess] = useState(false);
  const [rememberMe, setRememberMe] = useState<boolean>(
    localStorage.getItem("rememberMe") === "true",
  );

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();

  const { mutate, isPending } = useLoginMutation();
  const { refetch } = useProfileData();

  const handleLogin = (data: any) => {
    setEmail(data?.email);
    if (rememberMe) {
      localStorage.setItem("rememberedEmail", data.email);
      localStorage.setItem("rememberedPassword", data.password);
      localStorage.setItem("rememberMe", "true");
    } else {
      localStorage.removeItem("rememberedEmail");
      localStorage.removeItem("rememberedPassword");
      localStorage.setItem("rememberMe", "false");
    }
    mutate(
      { ...data, type: "LM" },
      {
        onSuccess: async (responseData) => {
          console.log("Login Success:", responseData);
          if (!responseData?.otpCode) {
            const profileResponse = await refetch();
            if (profileResponse?.data) {
              dispatch(addProfileData(profileResponse?.data));
              const user = profileResponse?.data;
              const hasNoWarehouse =
                !user?.isWarehouseCreated && !user?.warehouses?.length;

              if (hasNoWarehouse && user?.clientType !== "DS") {
                navigate("/create-warehouse");
              } else {
                navigate("/dashboard");
              }
            } else {
              toast.error("Failed to load user profile.");
            }
          } else {
            // If OTP is required, show the OtpForm
            setIsSuccess(true);
          }
        },
        onError: (error: any) => {
          console.error("Login Error:", error);
          toast.error(`Login failed: ${error}`);
        },
      },
    );
  };

  useEffect(() => {
    const remember = localStorage.getItem("rememberMe");
    if (remember === "true") {
      setValue("email", localStorage.getItem("rememberedEmail"));
      setValue("password", localStorage.getItem("rememberedPassword"));
    }
  }, [setValue]);

  return (
    <div className="bg-gradient-to-br from-[#f7f6ec] via-[#fff9df] to-[#ffe775] p-2">
      <div className="mx-auto flex   max-w-[1400px] overflow-hidden rounded-[38px] border border-white/70 bg-white/40 backdrop-blur-xl shadow-[0_28px_80px_rgba(36,30,10,0.14)]">
        {/* Left Login Panel */}
        <div className="w-[420px] shrink-0 bg-white/80 border-r border-[#ece8d6] p-6 flex flex-col">
          {/* Logo */}
          <div className="flex justify-start">
            <img
              //  src="/img/logo-tracktech-black.svg"
              src="/logo/logo-black.png"
              alt="Logo"
              className="2xl:w-52 w-52"
            />
          </div>
          {!isSuccess ? (
            <div className="mt-auto mb-auto">
              <div className="mb-5 inline-flex items-center gap-2 rounded-full border border-[#ffe99a] bg-[#fff7d0] px-4 py-2 text-xs font-bold text-[#8a6500]">
                <span className="h-2 w-2 rounded-full bg-green-500" />
                Live logistics workspace
              </div>
              <h1 className="text-5xl font-bold tracking-tight">
                Welcome Back
              </h1>
              <p className="mt-3 text-sm leading-6 text-gray-500">
                Welcome Back! Please Enter Your Details.
              </p>

              <form
                onSubmit={handleSubmit(handleLogin)}
                className="mt-8 space-y-5"
              >
                <Input
                  name="email"
                  type="text"
                  title="Email"
                  placeholder="Enter Your Email"
                  inputClassName="rounded-lg w-full py-2.5 px-4 text-base text-[#1E1E1E] border border-[#D8D8D8]"
                  register={register}
                  error={errors.email}
                  validation={{
                    required: "Email is required",
                    pattern: {
                      value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                      message: "Please enter a valid email address",
                    },
                  }}
                />

                <Input
                  name="password"
                  type="password"
                  title="Password"
                  placeholder="Enter Your Password"
                  inputClassName="rounded-lg w-full py-2.5 px-4 text-base text-[#1E1E1E] border border-[#D8D8D8]"
                  register={register}
                  error={errors.password}
                  validation={{ required: "Password is required" }}
                />

                <div className="flex justify-between items-center">
                  <label className="flex items-center gap-1 cursor-pointer">
                    <input
                      type="checkbox"
                      className="accent-[#FBD037] !scale-110"
                      checked={rememberMe}
                      onChange={(e) => setRememberMe(e.target.checked)}
                    />
                    <span className="text-[#1E1E1E] text-sm">Remember</span>
                  </label>

                  <NavLink
                    to="/forgot-password"
                    className="text-[#007BFF] text-sm"
                  >
                    Forgot password?
                  </NavLink>
                </div>

                <button
                  type="submit"
                  disabled={isPending}
                  className="w-full rounded-2xl bg-gradient-to-r from-[#ffd339] to-[#ffbf18] py-4 font-bold shadow-lg transition hover:-translate-y-0.5"
                >
                  {isPending ? "Logging in..." : "Login"}
                </button>
              </form>

              {/* Stats */}
              {/* <div className="mt-8 grid grid-cols-3 gap-3">
              <div className="rounded-2xl border border-[#f1e8bb] bg-[#fffdf2] p-3">
                <div className="text-lg font-bold">1.2k</div>
                <div className="text-xs text-gray-500">Orders Today</div>
              </div>

              <div className="rounded-2xl border border-[#f1e8bb] bg-[#fffdf2] p-3">
                <div className="text-lg font-bold">48</div>
                <div className="text-xs text-gray-500">Active Fleet</div>
              </div>

              <div className="rounded-2xl border border-[#f1e8bb] bg-[#fffdf2] p-3">
                <div className="text-lg font-bold">98%</div>
                <div className="text-xs text-gray-500">On-Time</div>
              </div>
            </div> */}
            </div>
          ) : (
            <OtpForm email={email} />
          )}
          <p className="mt-10 text-xs text-gray-400">
            © 2026 Najiz Express · Powered by Gwarm Technologies PVT LTD .
          </p>
        </div>

        {/* Right Visual Section */}
        <div className="flex-1 p-10">
          {/* Top Chips */}
          <div className="mb-6 flex flex-wrap items-center justify-between gap-4">
            <div className="flex flex-wrap gap-3">
              {[
                "📦 Shipments",
                "🧾 Orders",
                "🚚 Vehicles",
                "🔁 Inbound / Outbound",
              ].map((item) => (
                <div
                  key={item}
                  className="rounded-full border border-white/80 bg-white/70 px-4 py-2 text-sm font-semibold backdrop-blur"
                >
                  {item}
                </div>
              ))}
            </div>

            <div className="flex items-center gap-3 rounded-2xl bg-white/80 p-4 shadow-lg">
              <div>
                <div className="text-sm font-bold">Drivers Active Today</div>
                <div className="text-xs text-gray-500">12:30pm to 4:00pm</div>
              </div>

              <div className="flex -space-x-2">
                <div className="h-8 w-8 rounded-full bg-orange-400" />
                <div className="h-8 w-8 rounded-full bg-yellow-400" />
                <div className="h-8 w-8 rounded-full bg-green-400" />
              </div>
            </div>
          </div>

          {/* Main Hero */}
          <div className="grid h-[650px] grid-cols-[1.1fr_0.9fr] gap-5">
            <div className="relative overflow-hidden rounded-[32px]">
              <img
                src="https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?auto=format&fit=crop&w=1100&q=85"
                alt=""
                className="h-full w-full object-cover"
              />

              <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent" />

              <div className="absolute bottom-8 left-8 right-8 text-white">
                <h2 className="text-2xl font-bold">
                  Warehouse, fleet and shipment operations in one login
                  experience.
                </h2>

                <p className="mt-3 text-sm text-white/80">
                  Use realistic logistics visuals for inbound receiving, product
                  storage, vehicle movement and order tracking.
                </p>
              </div>
            </div>

            <div className="flex flex-col gap-5">
              <div className="grid grid-cols-2 gap-4">
                <div className="relative overflow-hidden rounded-[32px] h-40">
                  <img
                    src="https://images.unsplash.com/photo-1578575437130-527eed3abbec?auto=format&fit=crop&w=600&q=85"
                    alt="Warehouse worker handling products and packages"
                    className="h-full w-full object-cover"
                  />

                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent" />

                  <div className="absolute bottom-4 left-2 text-white">
                    <h2 className="text-lg font-bold">Inbound Receiving</h2>

                    <p className="text-sm text-white/80">
                      Scan, verify, sort, and store products
                    </p>
                  </div>
                </div>
                <div className="relative overflow-hidden rounded-[32px] h-40">
                  <img
                    src="https://images.unsplash.com/photo-1601584115197-04ecc0da31d7?auto=format&fit=crop&w=600&q=85"
                    alt="Truck fleet and logistics vehicle movement"
                    className="h-full w-full object-cover"
                  />

                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent" />

                  <div className="absolute bottom-4 left-2   text-white">
                    <h2 className="text-lg font-bold">Outbound Fleet</h2>

                    <p className="text-sm text-white/80">
                      Vehicle loading and route dispatch
                    </p>
                  </div>
                </div>
                <div className="relative overflow-hidden rounded-[32px] h-40">
                  <img
                    src="https://images.unsplash.com/photo-1617347454431-f49d7ff5c3b1?auto=format&fit=crop&w=900&q=80"
                    alt="Driver Pickup"
                    className="h-full w-full object-cover"
                  />

                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent" />
                </div>
                <div className="relative overflow-hidden rounded-[32px] h-40">
                  <img
                    src="/img/image (1).png"
                    alt="Truck fleet and logistics vehicle movement"
                    className="h-44 object-center"
                  />

                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent" />
                </div>
              </div>

              <div className="flex-1 rounded-[28px] bg-white/80 space-y-4 p-5 backdrop-blur shadow-xl">
                <div className="flex justify-between items-center ">
                  <div className="flex items-center gap-2">
                    <div className="h-3 w-3 rounded-full bg-orange-400 backdrop-blur shadow-lg" />
                    <div className="h-3 w-3 rounded-full bg-yellow-400 backdrop-blur shadow-lg" />
                    <div className="h-3 w-3 rounded-full bg-green-400 backdrop-blur shadow-lg" />
                  </div>
                  <h3 className=" font-bold">Najiz Live Dispatch Board</h3>
                </div>

                <div className="space-y-3">
                  {[
                    "NJZ-9821 · Electronics",
                    "NJZ-3401 · Medical Supplies",
                    "NJZ-1109 · Auto Parts",
                  ].map((item) => (
                    <div
                      key={item}
                      className="flex items-center justify-between rounded-2xl border bg-white p-3"
                    >
                      <div>
                        <div className="font-semibold">{item}</div>
                        <div className="text-xs text-gray-500">
                          Outbound Route
                        </div>
                      </div>

                      <span className="rounded-full bg-green-100 px-3 py-1 text-xs font-bold text-green-700">
                        Active
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* Bottom Stats */}
          <div className="mt-5 grid grid-cols-4 gap-4">
            {[
              ["Inbound Loads", "284"],
              ["Outbound Orders", "956"],
              ["Product Items", "8.6k"],
              ["Route ETA", "24m"],
            ].map(([label, value]) => (
              <div
                key={label}
                className="rounded-3xl bg-white/70 p-5 backdrop-blur shadow-lg"
              >
                <div className="text-xs font-bold uppercase text-gray-500">
                  {label}
                </div>

                <div className="text-xl font-bold">{value}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginSaudi;
